import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import { useQuery } from "@tanstack/react-query";

interface UseGitHubPRsSearchParams {
  connection: IntegrationConnection;
  query: string;
  enabled?: boolean;
}

export function useGitHubPRsSearch({
  connection,
  query,
  enabled = true,
}: UseGitHubPRsSearchParams) {
  return useQuery({
    queryKey: ["github-prs-search", connection?.id || "", query],
    queryFn: () => {
      return orgAPI.toolbox.execute<any[]>({
        integration_connection_id: connection?.id || "",
        action_name: "github-issues-and-prs-search",
        action_input: {
          query,
          type: "prs",
          max_results: 100,
        },
        // Typed PRs drive the rich row UI; their generic projections ride along
        // in data_generic and are what get placed on the canvas.
        entity_format: "both",
      });
    },
    enabled: enabled && !!connection?.id && !!query,
    staleTime: 1000 * 60,
  });
}
